import { useEffect, useRef, useState } from 'react';
import { useIsFetching } from '@tanstack/react-query';
import { Hourglass } from 'lucide-react';

/**
 * Overlay de carga inicial del dashboard: tapa la pantalla con un reloj de arena
 * girando hasta que TODAS las consultas (widgets) terminan. Se basa en
 * `useIsFetching()` de react-query: aparece al montar, se va cuando los fetches
 * en vuelo bajan a 0 tras haber empezado. Solo en la carga inicial — los cambios
 * de filtro posteriores los maneja el "Cargando…" de cada widget.
 */
export function DashboardLoadingOverlay() {
  const fetching = useIsFetching();
  const [done, setDone] = useState(false);
  const started = useRef(false);

  useEffect(() => {
    if (fetching > 0) started.current = true;
    if (started.current && fetching === 0) setDone(true);
  }, [fetching]);

  // Failsafe: si algo se cuelga, ocultar a los 12s para no bloquear la vista.
  useEffect(() => {
    const t = setTimeout(() => setDone(true), 12000);
    return () => clearTimeout(t);
  }, []);

  if (done) return null;

  return (
    <div className="fixed inset-0 z-[60] grid place-items-center bg-white/85 backdrop-blur-sm">
      <div className="flex flex-col items-center gap-4">
        <Hourglass className="h-14 w-14 animate-spin text-red-600" style={{ animationDuration: '1.6s' }} />
        <span className="text-sm font-semibold text-slate-500">Cargando dashboard…</span>
      </div>
    </div>
  );
}
